import { render, staticRenderFns } from "./SurveyQuestionForm.vue?vue&type=template&id=f2c5bb8c"
import script from "./SurveyQuestionForm.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionForm.vue?vue&type=style&index=0&id=f2c5bb8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports